/**
 * ActionCable ユーティリティ
 *
 * @description WebSocket接続のシングルトン管理を提供
 * @since 1.0.0
 */
import { createConsumer as railsCreateConsumer } from '@rails/actioncable';
/**
 * シングルトンのconsumerインスタンス
 */
let consumer = null;
/**
 * ActionCable consumerを作成（シングルトンパターン）
 *
 * @param url WebSocket接続URL（省略時は '/cable' を使用）
 * @returns ActionCable consumer インスタンス
 *
 * @example
 * ```typescript
 * import { createConsumer } from '@shared/utils/cable';
 *
 * const cable = createConsumer();
 * const subscription = cable.subscriptions.create('NotificationsChannel', {
 *   received(data) {
 *     console.log('Received:', data);
 *   }
 * });
 * ```
 */
export const createConsumer = (url) => {
    if (!consumer) {
        consumer = railsCreateConsumer(url || '/cable');
    }
    return consumer;
};
/**
 * 既存のconsumerインスタンスを取得
 *
 * @returns ActionCable consumer インスタンス（存在しない場合は新規作成）
 *
 * @example
 * ```typescript
 * import { getConsumer } from '@shared/utils/cable';
 *
 * const cable = getConsumer();
 * ```
 */
export const getConsumer = () => {
    return consumer || createConsumer();
};
/**
 * consumerインスタンスをリセット（テスト用）
 *
 * @internal
 */
export const resetConsumer = () => {
    if (consumer) {
        consumer.disconnect();
        consumer = null;
    }
};
